import React, { FC, memo, useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { useAppDispatch } from 'Src/hooks'
import cn from 'classnames'
import { ArticleModel, articleSelector, articleSlice } from 'Pages/knowledge'
import { useSelector } from 'react-redux'

interface ComponentProps {
	video: ArticleModel
}

export const VideoViewComponent: FC<ComponentProps> = memo(({ video }: ComponentProps) => {
	const [error, setError] = useState<string | undefined>()
	const { getUrl, clearS3FileUrl, getFullVideo, clearVideo } = useAppDispatch({
		getUrl: articleSlice.actions.getUrlVideo,
		getFullVideo: articleSlice.actions.getOneVideo,
		clearS3FileUrl: articleSlice.actions.clearUrlVideo,
		clearVideo: articleSlice.actions.clearArticle,
	})

	const s3FileUrl = useSelector(articleSelector.getUrlVideo)
	const fullVideo = useSelector(articleSelector.getArticle)

	const s3_file_name = video.s3_file_name || fullVideo?.s3_file_name
	const external_url = video.external_url || fullVideo?.external_url

	useEffect(() => {
		if (!(video.s3_file_name || video.external_url)) getFullVideo({ video })
		return () => clearVideo()
	}, [clearVideo, getFullVideo, video])

	useEffect(() => {
		if (s3_file_name) getUrl(s3_file_name)
		return () => clearS3FileUrl()
	}, [clearS3FileUrl, getUrl, s3_file_name])

	const className = cn('knowledge__video-wrapper', {
		'knowledge__video-wrapper--error': error,
	})

	if (!(external_url || s3FileUrl)) return null

	return (
		<div className={className}>
			<ReactPlayer
				url={external_url || s3FileUrl}
				controls
				width="100%"
				height={external_url ? '490px' : '100%'}
				onError={setError}
			/>
		</div>
	)
})
